export default class MotorwayPaymentCardModel {
    constructor() {
        this.registrationNumber = undefined;
        this.vehicleCategory = undefined;
        this.highwayEnabled = undefined;
        this.additionalServices = [];
    }

    static assign(from, to) {
        if (from) {
            to.registrationNumber = from.registrationNumber ? from.registrationNumber : undefined;
            to.vehicleCategory = from.highwayVehicleType ? from.highwayVehicleType : undefined;
            to.highwayEnabled = from.highwayEnabled ? from.highwayEnabled : false;
            to.additionalServices = from.additionalServices ? JSON.parse(JSON.stringify(MotorwayPaymentCardModel.sortAdditionalServices(from.additionalServices))) : [];
        } else {
            to = new MotorwayPaymentCardModel();
        }
    }

    static copy(from) {
        const to = new MotorwayPaymentCardModel();
        MotorwayPaymentCardModel.assign(from, to);
        return to;
    }

    static assignWithCategory(from, categories) {
        const to = new MotorwayPaymentCardModel();
        MotorwayPaymentCardModel.assign(from, to);
        to.vehicleCategory = from.highwayVehicleType ? categories.filter(c => c.name === from.highwayVehicleType)[0] : undefined;
        to.additionalServices = from.additionalServices ? JSON.parse(JSON.stringify(from.additionalServices)) : [];
        return to;
    }

    static sortAdditionalServices(list){
       return  list.sort((a, b) => {
        // Jeśli 'a' ma nazwę "ALL", to powinna być pierwsza
        if (a.name === 'ALL') return -1;
        // Jeśli 'b' ma nazwę "ALL", to powinna być pierwsza
        if (b.name === 'ALL') return 1;
        
        // Jeśli 'a' ma nazwę "HIGHWAYS_PRIVATE", to powinna być ostatnia
        if (a.name === 'HIGHWAYS_PRIVATE') return 1;
        // Jeśli 'b' ma nazwę "HIGHWAYS_PRIVATE", to powinna być ostatnia
        if (b.name === 'HIGHWAYS_PRIVATE') return -1;
        // Jeśli żadne z powyższych warunków nie pasuje, porównaj elementy naturalnie
        return 0;
      });}
}
